import { useCallback, useMemo } from 'react'
import { useRouter } from 'next/router'
import { routes } from 'routes'

export type PageParams = {
    companySlug: string
    page: number
    unpublished: boolean
}

export const usePageRouter = () => {
    const router = useRouter()
    const page = router.query['page'] as string | undefined
    const companySlug = router.query['slug'] as string
    const unpublishedParam = router.query['unpublished'] as string | undefined
    const unpublished = unpublishedParam === 'true'

    const params = useMemo(() => {
        return {
            companySlug,
            page: Number(page) || 1,
            unpublished,
        }
    }, [page, companySlug, unpublished])

    const nextPageLink = useMemo(() => {
        return routes.companyJobs({
            ...params,
            page: params.page + 1,
        })
    }, [params])

    const toggleUnPublish = useCallback(() => {
        router.push(
            routes.companyJobs({
                ...params,
                page: 1,
                unpublished: !params.unpublished,
            }),
            undefined,
            { shallow: true },
        )
    }, [params])

    return { params, toggleUnPublish, nextPageLink }
}
